var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import TextArea from 'antd/lib/input/TextArea';
import Modal from 'antd/lib/modal';
import notification from 'antd/lib/notification';
import React from 'react';
import { MessageTemplateQuery, TicketQuery } from 'renderer/queries';
import styled, { css } from 'styled-components';
import { KRWFomatToString, TextComponent, FormItemLabel, StyledFormItem, typographyByName, ZIndexer, EntireLoader, ContentLoader } from 'renderer/components';
import { TICKET_TYPE } from 'renderer/models';
import { checkIsIOS, getByteLength, useWindowSize } from 'renderer/utils';
import { CustomerPointModel } from 'renderer/models';
import Form from 'antd/lib/form';
import { AntdForm, InputByType } from './Forms';
import { Col, Row } from 'antd/lib/grid';
import Switch from 'antd/lib/switch';
import * as dayjs from 'dayjs';
import { COLORS, MediaQuery } from 'renderer/styles';
export var getPrepaidMessageBody = function (params) {
    return "".concat(params.customerName, "\uB2D8 \uC120\uBD88\uC561 \uC0AC\uC6A9 ").concat(KRWFomatToString({
        value: params.usedPrepaidPoint
    }), ", \uC794\uC561  ").concat(KRWFomatToString({
        value: params.remainPrepaidPoint
    }), "\uC785\uB2C8\uB2E4. \uAC10\uC0AC\uD569\uB2C8\uB2E4. -").concat(params === null || params === void 0 ? void 0 : params.storeName, "-\n    ");
};
export var TextAreaWithByteChecker = function (props) {
    return (React.createElement(Wrapper, null,
        React.createElement(StyledTextArea, { value: props.value, onChange: props.onChange }),
        props.value && React.createElement(StyledByteChecker, { text: props.value })));
};
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  border-radius: 2px;\n  border: solid 1px var(--gray-6);\n"], ["\n  position: relative;\n  border-radius: 2px;\n  border: solid 1px var(--gray-6);\n"])));
var StyledTextArea = styled(TextArea)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 0;\n  resize: none;\n  height: 300px;\n  &:focus {\n    box-shadow: 0 0 0 0px rgb(150 117 248 / 20%);\n  }\n"], ["\n  border: 0;\n  resize: none;\n  height: 300px;\n  &:focus {\n    box-shadow: 0 0 0 0px rgb(150 117 248 / 20%);\n  }\n"])));
export var ModalWithClick = function (props) {
    var modalStyle = props.modalStyle;
    var modalWidth = modalStyle.modalWidth || 200;
    var _a = useWindowSize(), width = _a.width, height = _a.height;
    var getModalStyle = function () {
        if (modalStyle) {
            var top = modalStyle.top;
            var left = modalStyle.left;
            if (modalStyle.top > height / 2) {
                top = top - modalStyle.topOffset;
            }
            if (modalStyle.left > width / 2) {
                left = left - modalWidth;
            }
            return __assign(__assign({}, modalStyle), { top: top, left: left });
        }
    };
    return (modalStyle && (React.createElement(StyledModal, { width: modalWidth, visible: !!modalStyle, onCancel: props.onClose, maskStyle: { backgroundColor: 'transparent' }, closable: false, footer: null, style: modalStyle && __assign(__assign({}, getModalStyle()), { margin: 0 }) }, props.children)));
};
var StyledModal = styled(Modal)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  & .ant-modal-body {\n    padding: 0;\n  }\n\n  & .ant-modal-content {\n    padding: 0;\n    border-radius: 4px;\n    border: solid 1px var(--gray-6);\n    position: relative;\n    background-color: #fff;\n    background-clip: padding-box;\n    box-shadow:\n      0 0px 0px 0px rgb(0 0 0 / 12%),\n      0 0px 0px 0px rgb(0 0 0 / 8%),\n      0 0px 0px 0px rgb(0 0 0 / 5%);\n    pointer-events: auto;\n  }\n"], ["\n  & .ant-modal-body {\n    padding: 0;\n  }\n\n  & .ant-modal-content {\n    padding: 0;\n    border-radius: 4px;\n    border: solid 1px var(--gray-6);\n    position: relative;\n    background-color: #fff;\n    background-clip: padding-box;\n    box-shadow:\n      0 0px 0px 0px rgb(0 0 0 / 12%),\n      0 0px 0px 0px rgb(0 0 0 / 8%),\n      0 0px 0px 0px rgb(0 0 0 / 5%);\n    pointer-events: auto;\n  }\n"])));
export var UpdateTicketModal = function (props) {
    var data = props.data, rest = __rest(props, ["data"]);
    var ticket = data.ticket, customerPoint = data.customerPoint;
    var today = dayjs();
    var disabledDate = function (current) {
        // return today.endOf('day').isAfter(current);
        return false;
    };
    var remain = (customerPoint === null || customerPoint === void 0 ? void 0 : customerPoint.latestRemain) || 0;
    var _a = React.useReducer(function (x) { return x + 1; }, 0), forceUpdate = _a[1];
    // const
    var form = Form.useForm()[0];
    var FIELDS = {
        description: {
            type: 'text',
            itemProps: {
                name: 'description',
                label: '내역',
                rules: [{ type: 'string', required: true }]
            },
            inputProps: {
                placeholder: '내용을 입력해주세요.'
            }
        },
        amount: function (label, max, min, isNotWon) {
            if (min === void 0) { min = 1; }
            return ({
                type: 'number',
                itemProps: {
                    name: 'amount',
                    label: label,
                    rules: [{ type: 'number', required: true, min: min, max: max }]
                },
                inputProps: {
                    placeholder: "".concat(label, "\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."),
                    suffix: isNotWon ? '회' : '원'
                }
            });
        },
        expiredAt: {
            element: (React.createElement("div", null,
                React.createElement(FormItemLabel, { children: "\uC720\uD6A8\uAE30\uAC04" }),
                React.createElement(Row, { style: { width: '100%' }, gutter: 8 },
                    React.createElement(Col, null,
                        React.createElement(Form.Item, { wrapperCol: { span: 2 }, name: "expiredAtActive" },
                            React.createElement(Switch, { checked: form.getFieldValue(['expiredAtActive']), onChange: function (checked) {
                                    if (checked && !form.getFieldValue(['expiredAt'])) {
                                        form.setFieldsValue({ expiredAt: defaultExpiredAt });
                                    }
                                    form.validateFields();
                                    forceUpdate();
                                } }))),
                    React.createElement(Col, { flex: 1 },
                        React.createElement(Form.Item, { name: "expiredAt", wrapperCol: { span: 24 } }, InputByType({
                            type: 'datepicker',
                            inputProps: {
                                onChange: function () {
                                    form.validateFields();
                                },
                                disabledDate: disabledDate,
                                disabled: !form.getFieldValue(['expiredAtActive'])
                            }
                        }))))))
        },
        duration: {
            element: (React.createElement("div", null,
                React.createElement(Row, { style: { width: '100%' }, gutter: 8 },
                    React.createElement(Col, { flex: 1 },
                        React.createElement(StyledFormItem, { name: ['data', 'startedAt'], dependencies: [['data', 'startedAt'], ['expiredAt']], labelCol: { span: 24 }, wrapperCol: { span: 24 }, label: "\uC0AC\uC6A9\uAE30\uAC04(\uC2DC\uC791\uC77C)", rules: [
                                {
                                    type: 'date',
                                    required: true,
                                    validator: function (_, value) {
                                        var expiredAtActive = form.getFieldValue(['expiredAtActive']);
                                        var ticketExpiredAt = form.getFieldValue(['expiredAt']);
                                        if (expiredAtActive && ticketExpiredAt) {
                                            if (value.isAfter(ticketExpiredAt) || value.isSame(ticketExpiredAt, 'day')) {
                                                return Promise.reject('시작일과 종료일은 티켓유효기간 이전이어야합니다.');
                                            }
                                        }
                                        var expiredAt = form.getFieldValue(['data', 'expiredAt']);
                                        if (value.isAfter(expiredAt, 'hour') || value.isSame(expiredAt, 'day')) {
                                            return Promise.reject('시작일을 종료일보다 이전으로 지정해주세요.');
                                        }
                                        return Promise.resolve();
                                    }
                                }
                            ] }, InputByType({
                            type: 'datepicker',
                            inputProps: {
                                onChange: function () {
                                    form.validateFields();
                                }
                                // disabledDate: disabledDate
                            }
                        }))),
                    React.createElement(Col, { flex: 1 },
                        React.createElement(StyledFormItem, { name: ['data', 'expiredAt'], dependencies: [['data', 'expiredAt'], ['expiredAt']], labelCol: { span: 24 }, wrapperCol: { span: 24 }, label: "\uC0AC\uC6A9\uAE30\uAC04(\uC885\uB8CC\uC77C)", rules: [
                                {
                                    type: 'date',
                                    required: true,
                                    validator: function (_, value) {
                                        var expiredAtActive = form.getFieldValue(['expiredAtActive']);
                                        var ticketExpiredAt = form.getFieldValue(['expiredAt']);
                                        if (expiredAtActive && ticketExpiredAt) {
                                            if (value.isAfter(ticketExpiredAt, 'day')) {
                                                return Promise.reject('시작일과 종료일은 티켓유효기간 이전이어야합니다.');
                                            }
                                        }
                                        var startedAt = form.getFieldValue(['data', 'startedAt']);
                                        if (value.isBefore(startedAt, 'hour') || value.isSame(startedAt, 'day')) {
                                            return Promise.reject('종료일을 시작일 이후로 지정해주세요.');
                                        }
                                        return Promise.resolve();
                                    }
                                }
                            ] }, InputByType({
                            type: 'datepicker',
                            inputProps: {
                                onChange: function () {
                                    form.validateFields();
                                }
                            }
                        }))))))
        }
    };
    React.useEffect(function () {
        form.resetFields();
        forceUpdate();
    }, [props.data]);
    var getProps = function () {
        return ticket
            ? ticket.type === TICKET_TYPE.CHARGING_MONEY
                ? {
                    title: '선불액 조정',
                    fields: [FIELDS.description, FIELDS.amount('잔여금액', 100000000, 0), FIELDS.expiredAt],
                    initialValues: {
                        description: '임의조정',
                        expiredAtActive: !!ticket.expiredAt,
                        amount: ticket.data.remain || 0,
                        expiredAt: ticket.expiredAt ? dayjs(ticket.expiredAt) : undefined
                    },
                    isChanged: function () {
                        return (!dayjs(ticket.expiredAt).isSame(form.getFieldValue(['expiredAt']), 'day') ||
                            form.getFieldValue(['amount']) !== ticket.data.remain ||
                            !!ticket.expiredAt !== form.getFieldValue(['expiredAtActive']));
                    }
                }
                : {
                    title: '정기권 조정',
                    fields: [
                        FIELDS.description,
                        ticket.type === TICKET_TYPE.COUNT ? FIELDS.amount('잔여횟수', 1000, 0, true) : FIELDS.duration,
                        FIELDS.expiredAt
                    ],
                    initialValues: {
                        description: '임의조정',
                        expiredAtActive: !!ticket.expiredAt,
                        expiredAt: ticket.expiredAt ? dayjs(ticket.expiredAt) : undefined,
                        amount: ticket.data.remain,
                        data: {
                            startedAt: dayjs(ticket.data.startedAt),
                            expiredAt: dayjs(ticket.data.expiredAt)
                        }
                    },
                    isChanged: function () {
                        return ((ticket.type === TICKET_TYPE.COUNT
                            ? form.getFieldValue(['amount']) !== ticket.data.remain
                            : !dayjs(ticket.data.startedAt).isSame(form.getFieldValue(['data', 'startedAt'])) ||
                                !dayjs(ticket.data.expiredAt).isSame(form.getFieldValue(['data', 'expiredAt']))) ||
                            !dayjs(ticket.expiredAt).isSame(form.getFieldValue(['expiredAt']), 'day') ||
                            !!ticket.expiredAt !== form.getFieldValue(['expiredAtActive']));
                    }
                }
            : (customerPoint === null || customerPoint === void 0 ? void 0 : customerPoint.id)
                ? {
                    title: '유효기간 수정',
                    fields: [FIELDS.expiredAt],
                    initialValues: {
                        description: '임의충전',
                        expiredAtActive: !!customerPoint.expiredAt,
                        expiredAt: customerPoint.expiredAt ? dayjs(customerPoint.expiredAt) : undefined
                    },
                    isChanged: function () {
                        return (!dayjs(customerPoint.expiredAt).isSame(form.getFieldValue(['expiredAt']), 'day') ||
                            !!customerPoint.expiredAt !== form.getFieldValue(['expiredAtActive']));
                    }
                }
                : (customerPoint === null || customerPoint === void 0 ? void 0 : customerPoint.type) === CustomerPointModel.POINT_TYPE.USED
                    ? {
                        title: '포인트 차감',
                        fields: [FIELDS.description, FIELDS.amount('차감액', remain, 1)],
                        initialValues: { description: '임의차감' }
                    }
                    : {
                        title: '포인트 충전',
                        fields: [FIELDS.description, FIELDS.amount('충전액', 100000000, 1), FIELDS.expiredAt],
                        initialValues: { description: '임의충전', expiredAtActive: true, expiredAt: defaultExpiredAt }
                    };
    };
    var defaultExpiredAt = today.add(1, 'year').subtract(1, 'day').endOf('day');
    var createPointHistory = TicketQuery.useCreateCustomerPointHistory();
    var updatePointHistory = TicketQuery.useUpdateCustomerPointHistory();
    var updateTicket = TicketQuery.useUpdateTicket();
    var handleSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var message, data_1, ticketData, payload, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 8, , 9]);
                    if (!customerPoint) return [3 /*break*/, 5];
                    data_1 = customerPoint.type === CustomerPointModel.POINT_TYPE.USED
                        ? __assign(__assign({}, customerPoint), { change: values.amount, description: values.description }) : __assign(__assign({}, customerPoint), { expiredAt: values.expiredAtActive ? values.expiredAt : undefined, change: values.amount, description: values.description });
                    if (!customerPoint.id) return [3 /*break*/, 2];
                    return [4 /*yield*/, updatePointHistory.mutateAsync({
                            id: customerPoint.id,
                            storeId: customerPoint.storeId,
                            expiredAt: values.expiredAtActive ? values.expiredAt : undefined
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, createPointHistory.mutateAsync(data_1)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    message = '포인트 수정이 완료되었습니다.';
                    return [3 /*break*/, 7];
                case 5:
                    if (!ticket) return [3 /*break*/, 7];
                    if (!ticket.id) return [3 /*break*/, 7];
                    ticketData = ticket.type === TICKET_TYPE.TERM
                        ? { startedAt: values.data.startedAt, expiredAt: values.data.expiredAt }
                        : { remain: values.amount };
                    payload = __assign(__assign({}, ticket), { expiredAt: values.expiredAtActive ? values.expiredAt : undefined, data: __assign(__assign({}, ticket.data), ticketData), historyDescription: values.description });
                    return [4 /*yield*/, updateTicket.mutateAsync(payload)];
                case 6:
                    _b.sent();
                    message = "".concat(((_a = ticket.copiedTicketTemplate) === null || _a === void 0 ? void 0 : _a.getTypeToString()) || '정기권', " \uC218\uC815\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                    _b.label = 7;
                case 7:
                    if (message) {
                        notification.success({ message: message });
                    }
                    return [3 /*break*/, 9];
                case 8:
                    error_1 = _b.sent();
                    notification.error({ message: error_1.message });
                    return [3 /*break*/, 9];
                case 9:
                    if (!!message) {
                        props.onCancel(undefined);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var _b = getProps(), title = _b.title, fields = _b.fields, initialValues = _b.initialValues, isChanged = _b.isChanged;
    return (React.createElement(BigTitleModal, __assign({}, rest, { centered: true, maskClosable: false, cancelText: "\uB2EB\uAE30", okText: "\uC800\uC7A5", okButtonProps: {
            disabled: isChanged ? !isChanged() : false
        }, onOk: function () { return form.submit(); }, title: title, open: !!data, children: React.createElement(BigTitleModalContent, null,
            customerPoint && (React.createElement(TextComponent, { type: "headline3", marginBottom: 15, children: "\uC794\uC5EC \uD3EC\uC778\uD2B8 : ".concat(KRWFomatToString({ value: remain })) })),
            React.createElement(AntdForm, { fields: fields, formProps: {
                    onFinish: handleSubmit,
                    layout: 'vertical',
                    form: form,
                    initialValues: initialValues,
                    onValuesChange: function () {
                        forceUpdate();
                    }
                }, onSubmit: handleSubmit })) })));
};
var BigTitleModalContent = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 20px;\n"], ["\n  padding: 20px;\n"])));
export var BigTitleModal = function (props) {
    var open = props.visible || props.open;
    return open ? (React.createElement(ZIndexer, null, function (_a) {
        var zIndex = _a.zIndex;
        return (React.createElement(StyledBigTitleModal, __assign({}, props, { zIndex: zIndex, open: open, okButtonProps: __assign({ size: 'large' }, props.okButtonProps), cancelButtonProps: __assign({ size: 'large' }, props.cancelButtonProps) })));
    })) : (React.createElement("div", null));
};
export var AsyncEntireBigTitleModal = function (props) {
    var isIos = checkIsIOS();
    var open = props.open;
    var _a = React.useState(false), contentLoaded = _a[0], setContentLoaded = _a[1];
    var _b = React.useState(true), showLoader = _b[0], setShowLoader = _b[1];
    var onOpenChange = React.useCallback(function (openComplete) {
        if (openComplete) {
            setContentLoaded(true);
            setShowLoader(false);
        }
        else {
            setContentLoaded(false);
            setShowLoader(true);
        }
    }, []);
    if (!isIos) {
        return React.createElement(EntireBigTitleModal, __assign({}, props), props.children);
    }
    return (React.createElement(React.Fragment, null,
        open && showLoader && React.createElement(EntireLoader, { open: !contentLoaded }),
        open && (React.createElement(EntireBigTitleModal, __assign({}, props, { open: open, afterOpenChange: onOpenChange }), !contentLoaded ? React.createElement(ContentLoader, null) : props.children))));
};
export var StyledBigTitleModal = styled(Modal)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  & .ant-modal-title {\n    text-align: center;\n    ", "} \n  }\n  .ant-modal-header {\n    padding: 16px 24px;\n  }\n  & .ant-modal-content {\n    padding: 0px !important;\n  }\n  .ant-modal-body {\n    padding: 0px !important;\n  }\n  .ant-modal-footer {\n    display: flex;\n    background: transparent;\n    border-radius: 0 0 2px 2px;\n    padding: 10px 16px;\n    text-align: right;\n\n     & > button {\n       flex:1;\n     }\n  }\n  .ant-modal-close-x {\n    color: ", "\n  }\n"], ["\n  & .ant-modal-title {\n    text-align: center;\n    ", "} \n  }\n  .ant-modal-header {\n    padding: 16px 24px;\n  }\n  & .ant-modal-content {\n    padding: 0px !important;\n  }\n  .ant-modal-body {\n    padding: 0px !important;\n  }\n  .ant-modal-footer {\n    display: flex;\n    background: transparent;\n    border-radius: 0 0 2px 2px;\n    padding: 10px 16px;\n    text-align: right;\n\n     & > button {\n       flex:1;\n     }\n  }\n  .ant-modal-close-x {\n    color: ", "\n  }\n"])), css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), typographyByName('headline2')), COLORS.black);
export var EntireBigTitleModal = styled(BigTitleModal)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  height: 100vh;\n  width: 100vw;\n  margin: 0 !important;\n  top: 0;\n\n  & .ant-modal-title {\n    text-align: center;\n    ", "} \n  }\n\n  & .ant-modal-content {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n\n    height: 100vh;\n    width: 90vw;\n    left: 10vw;\n    ", ";\n  }\n  .ant-modal-header {\n    background: #fff;\n    border-bottom: 1px solid ", ";\n    border-radius: 2px 2px 0 0;\n    color: rgba(0, 0, 0, 0.85);\n    padding: 16px 24px;\n    margin-bottom: 0;\n  }\n  & .ant-modal-body {\n    flex: 1;\n    overflow: hidden;\n  }\n  .ant-modal-footer {\n    display: flex;\n    background: transparent;\n    border-radius: 0 0 2px 2px;\n    padding: 10px 16px;\n    text-align: right;\n\n     & > button {\n       flex:1;\n     }\n  }\n  .ant-modal-close-x {\n    color: ", "\n  }\n"], ["\n  height: 100vh;\n  width: 100vw;\n  margin: 0 !important;\n  top: 0;\n\n  & .ant-modal-title {\n    text-align: center;\n    ", "} \n  }\n\n  & .ant-modal-content {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n\n    height: 100vh;\n    width: 90vw;\n    left: 10vw;\n    ", ";\n  }\n  .ant-modal-header {\n    background: #fff;\n    border-bottom: 1px solid ", ";\n    border-radius: 2px 2px 0 0;\n    color: rgba(0, 0, 0, 0.85);\n    padding: 16px 24px;\n    margin-bottom: 0;\n  }\n  & .ant-modal-body {\n    flex: 1;\n    overflow: hidden;\n  }\n  .ant-modal-footer {\n    display: flex;\n    background: transparent;\n    border-radius: 0 0 2px 2px;\n    padding: 10px 16px;\n    text-align: right;\n\n     & > button {\n       flex:1;\n     }\n  }\n  .ant-modal-close-x {\n    color: ", "\n  }\n"])), css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), typographyByName('headline2')), MediaQuery.tabletWithMobile(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 100vw;\n    left: 0;\n  "], ["\n    width: 100vw;\n    left: 0;\n  "]))), COLORS.gray5, COLORS.black);
export var checkSMSService = function (store, openSetting, message) { return __awaiter(void 0, void 0, void 0, function () {
    var data, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, MessageTemplateQuery.getMessageSettings({ queryKey: ['', store.id], meta: {} })];
            case 1:
                data = _a.sent();
                if (!!data.messageSendInfo) {
                    return [2 /*return*/, true];
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        Modal.confirm({
                            zIndex: 100000,
                            centered: true,
                            icon: null,
                            title: React.createElement(TextComponent, { children: "\uBB38\uC790 \uBC1C\uC2E0\uC815\uBCF4 \uC124\uC815", type: "headline2" }),
                            cancelButtonProps: {
                                // ghost: true,
                                // type: 'primary',
                                style: { display: history ? 'block' : 'none' }
                            },
                            onOk: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (openSetting) {
                                        openSetting({
                                            type: 'senderInfo'
                                        });
                                    }
                                    return [2 /*return*/, resolve(false)];
                                });
                            }); },
                            onCancel: function () {
                                return resolve(false);
                            },
                            okText: history ? '등록하기' : '닫기',
                            cancelText: '닫기',
                            content: (React.createElement("div", null,
                                React.createElement(TextComponent, { type: "16m", color: COLORS.gray1, children: message || '문자발송 기능을 이용하기 위해서는' }),
                                React.createElement(TextComponent, { type: "16m", color: COLORS.gray1, children: "\uBB38\uC790 \uBC1C\uC2E0\uC815\uBCF4 \uC124\uC815\uC774 \uD544\uC694\uD569\uB2C8\uB2E4." }),
                                React.createElement(TextComponent, { type: "16m", color: COLORS.gray1, children: "\uBC1C\uC2E0\uC815\uBCF4\uB97C \uBA3C\uC800 \uB4F1\uB85D\uD574\uC8FC\uC138\uC694", marginBottom: 5 })))
                        });
                    })];
            case 2:
                error_2 = _a.sent();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var modal = Modal.error({
                            zIndex: 100000,
                            centered: true,
                            icon: null,
                            title: React.createElement(TextComponent, { children: "\uBB38\uC790 \uBC1C\uC2E0\uC815\uBCF4 \uC124\uC815", type: "headline2" }),
                            cancelButtonProps: {
                                ghost: true,
                                type: 'primary',
                                style: { flex: 1 }
                            },
                            onOk: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    modal.destroy();
                                    return [2 /*return*/, resolve(false)];
                                });
                            }); },
                            content: (React.createElement("div", null,
                                React.createElement(TextComponent, { type: "16m", color: COLORS.gray1, children: message || '문자서비스 설정 중 문제가 발생했습니다. 고객센터로 문의주세요.' })))
                        });
                    })];
            case 3: return [2 /*return*/];
        }
    });
}); };
var ByteChecker = function (props) {
    var type = { SMS: 90, LMS: 2000 };
    var _a = React.useState(0), byte = _a[0], setByte = _a[1];
    React.useEffect(function () {
        setByte(getByteLength(props.text));
    }, [props.text]);
    var getType = function (byte) {
        return byte < type.SMS ? 'SMS' : 'LMS';
    };
    return (React.createElement(ByteText, { textAlign: "right", color: COLORS.gray4, type: "caption1", className: props.className, children: "".concat(byte, " / ").concat(type[getType(byte)], " (").concat(getType(byte), ")") }));
};
var ByteText = styled(TextComponent)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin: 8px 12px;\n"], ["\n  margin: 8px 12px;\n"])));
var StyledByteChecker = styled(ByteChecker)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  right: 0px;\n  bottom: 0px;\n"], ["\n  right: 0px;\n  bottom: 0px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
